module.exports = __webpack_public_path__ + "img/4.ca18aa89.jpg";